import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import renderToggleButtonField from "src/shared/components/form/ToggleButton";
import { GRL_URL } from '../../../../../utils/pnd/PndConstants';
import { isNumber, pollingIntervalValidation } from "src/utils/validationUtils";
import renderSelectField from "src/shared/components/form/Select";
import { isNumberWithOutZero } from 'src/utils/validationUtils';
const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-animated-group">
        <div className="form__form-animated-group">
            <input
                {...input}
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

const UpdateClientInformation = ({ setMapData, status, handleSubmit, setAddressMap, address,subscriptionPlanOptions,paymentPlanOptions }) => {
    const apaFrameRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    // const [apaIframeUrl, setApaIframeUrl] = useState(GRL_URL);
    const [isAddress, setAddress] = useState(null);
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    setAddressMap(data_from_apa);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);
                    const latitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 10);
                    const longitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 9);
                    // if (buildingName) {
                    //     deliveryAddress = deliveryAddress + buildingName.Value + ",";
                    // }
                    // if (landmark && !buildingName === landmark) {
                    //     deliveryAddress = deliveryAddress + landmark.Value + ",";
                    // }
                    if (buildingName && buildingName?.Value!=="") {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                    }
                    if(buildingName?.Value==="" && landmark?.Value!==""){
                      deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }
                    if (street) {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area) {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone) {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city) {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates) {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }
                    if (deliveryAddress && deliveryAddress.includes(",,")) {
                        setAddress(deliveryAddress.replace(/,,/g, ','));
                        setMapData(deliveryAddress.replace(/,,/g, ','));
                    }
                    if (latitude) {
                        //  setLatitude(latitude.Value);
                    }
                    if (longitude) {
                        //   setLongitide(longitude.Value);
                    }
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string');
            }
        }
    };
    const handleMessageToIframe = () => {
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        } else {
            console.error('iframe element not found');
        }
    };
    return (
        // <Container>
        <>
            <form className="form-animated" onSubmit={handleSubmit}>
                <Col lg={12} md={12}>
                    <Row>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Account No.</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="accountNo" component={renderField} type="text" placeholder="Enter Client Account No." validate={[required]} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={8} md={8}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Client Name</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="clientName" component={renderField} type="text" placeholder="Enter Client Full Name" validate={[required]} />
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <Row>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Mobile No.</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="mobileNo" component={renderField} type="text" placeholder="971xxxxxxxx" validate={[required]} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>

                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Email Id</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="emailId" component={renderField} type="text" placeholder="Client Email Id" validate={[required]} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className="form__form-animated-group-label">Telephone No.</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="telephone" component={renderField} type="text" placeholder="Client Telephone No." />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={12}>
                            <div className="form__form-animated-group">
                                <span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">
                                    Client Address
                                </span>
                                <div className="form__form-animated-group-field">
                                    <input
                                        validate={required}
                                        component="textarea"
                                        name="address"
                                        type="text"
                                        value={isAddress || address}
                                    />
                                    <AddLocationAltIcon color="success" fontSize="large" style={{ cursor: 'pointer' }} onClick={toggleModal} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group"><span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Account Dept. Contact Name</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="clientAccountantName" component={renderField} type="text" placeholder="Client Mobile No" validate={[required]}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>

                            <div className="form__form-animated-group"><span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Accountant Dept. Contact Number</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="clientAccountantMobile" component={renderField} type="text" placeholder="Client Email Id" validate={[required]}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group"><span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Account Dept. Email Id</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="clientAccountantEmail" component={renderField} type="text" placeholder="Client Email Id" validate={[required]} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className="form__form-animated-group-label">Tech. Contact Name</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="clientTechName" component={renderField} type="text" placeholder="Client Mobile No" />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>

                            <div className="form__form-animated-group">
                                <span className="form__form-animated-group-label">Tech. Contact Number</span>
                                <div className="form__form-animated-group-field">
                                    <Field name="clientTechMobileNo" component={renderField} type="text" placeholder="Client Email Id" />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-groupgroup">
                                <div className="form__form-animated-group">
                                    <span className="required_field">* </span>{" "}
                                    <span className="form__form-animated-group-label">Operational Status</span>
                                    <div className="form__form-animated-group-field">
                                        <Field
                                            name="status"
                                            component={renderToggleButtonField}
                                            defaultChecked={status}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} lg={4}>
                            <div className="form__form-animated-group">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Subscription Start Date</span>
                                    <div className="form__form-group-field">
                                        <Field name="subscriptionStartDate" component={renderField} type="text"
                                        />

                                        {/* onChange={dateRange_buffer} */}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={4} lg={4}>
                            <div className="form__form-animated-group">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Subscription End Date</span>
                                    <div className="form__form-group-field">

                                        <Field name="subscriptionEndDate" component={renderField} type="text"
                                        />
                                        {/* onChange={dateRange_buffer} */}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-group">
                                <span className='required_field'>* </span><span className="form__form-group-label">Time Zone</span>
                                <div className="form__form-group-field">

                                    <Field
                                        validate={[required]}
                                        name="timeZoneInfo"
                                        component={renderSelectField}
                                        type="text"
                                        label="Time Zone"
                                        placeholder="Select Time Zone"
                                        options={[{ value: 1, label: "Asia/Dubai" }]}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={4} md={4}>
                            <div className="form__form-group"><span className='required_field'>* </span>
                                <span className="form__form-group-label">Active Polling Interval (in sec)</span>
                                <div className="form__form-group-field">
                                    <Field name="activePollingInterval" component={renderField} type="text" placeholder="Active Polling Interval" validate={[pollingIntervalValidation, isNumber, required]} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-group"><span className='required_field'>* </span>
                                <span className="form__form-group-label">In-Active Polling Interval (in sec)</span>
                                <div className="form__form-group-field">
                                    <Field name="inactivePollingInterval" component={renderField} type="text" placeholder="In-Active Polling Interval" validate={[pollingIntervalValidation, isNumber, required]} />
                                </div>
                            </div>
                        </Col>

                        {/* <Col lg={3} md={3}>
                                <div className="form__form-group"><span className='required_field'>* </span>
                                    <span className="form__form-group-label">ETA Polling Interval (in min)</span>
                                    <div className="form__form-group-field">
                                        <Field name="etaPollingInterval" component={renderField} type="text" placeholder="ETA Polling Interval" validate={[isNumber, required]} />
                                    </div>
                                </div>
                            </Col> */}
                        <Col lg={4} md={4}>
                            <div className="form__form-group"><span className='required_field'>* </span>
                                <span className="form__form-group-label">Delivery Polling Interval (in sec)</span>
                                <div className="form__form-group-field">
                                    <Field name="deliveryPollingInterval" component={renderField} type="text" placeholder="Delivery Polling Interval" validate={[pollingIntervalValidation, isNumber, required]} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                       
                        <Col lg={4} md={4}>

                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Allowed Device</span>
                                <div className="form__form-group-field">
                                    <Field name="maxDeviceCount" component={renderField} type="text" placeholder="Allowed Device" validate={[isNumberWithOutZero, required]}
                                        value={subscriptionPlanOptions?.deviceCount} />

                                </div>
                            </div>
                        </Col>

                        {/* <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Allowed SMS</span>
                                <div className="form__form-group-field">
                                    <Field name="maxSmsCount" component={renderField} type="text" placeholder="Allowed SMS" validate={[isNumberWithOutZero, required]} />
                                </div>
                            </div>
                        </Col> */}
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Allowed Hub</span>
                                <div className="form__form-group-field">
                                    <Field name="maxHubCount" component={renderField} type="text" placeholder="Allowed Hub" validate={[isNumberWithOutZero, required]} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                        
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Allowed Hub Manager</span>
                                <div className="form__form-group-field">
                                    <Field name="maxHubManagerCount" component={renderField} type="text" validate={[isNumberWithOutZero, required]} disabled={true} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Allowed Hub Operator</span>
                                <div className="form__form-group-field">
                                    <Field name="maxHubOperatorCount" component={renderField} type="text" validate={[isNumberWithOutZero, required]} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Allowed Merchant</span>
                                <div className="form__form-group-field">
                                    <Field name="maxMerchantCount" component={renderField} type="text" placeholder="Allowed Merchant" validate={[isNumberWithOutZero, required]} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                       
                        <Col lg={4} md={4}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Allowed User per Merchant</span>
                                <div className="form__form-group-field">
                                    <Field name="perMaxMerchantUserCount" component={renderField} type="text" placeholder="Allowed User per Merchant" validate={[isNumberWithOutZero, required]} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                                <div className="form__form-group">
                                    <span className='required_field'>* </span><span className="form__form-group-label">Subscription Plan</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            validate={[required]}
                                            name="customerSubscriptionPlanInfo"
                                            component={renderSelectField}
                                            type="text"
                                            label="state"
                                            placeholder="Select Subscription Plan"
                                            options={subscriptionPlanOptions}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col lg={4} md={4}>
                                <div className="form__form-group">
                                    <span className='required_field'>* </span><span className="form__form-group-label">Payment Plan</span>
                                    <div className="form__form-group-field">

                                        <Field
                                            validate={[required]}
                                            name="customerPaymentPlanInfo"
                                            component={renderSelectField}
                                            type="text"
                                            label="state"
                                            placeholder="Select Payment Plan"
                                            options={paymentPlanOptions}
                                        />
                                    </div>
                                </div>
                            </Col>
                    </Row>
                </Col>

                <div className="form__OnboardingButton">
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        {/* <Button color="primary" type="button" className="previous" onClick={() => back()}>Back</Button> */}
                        <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                    </ButtonToolbar>
                </div>
            </form>

            <Modal isOpen={modalOpen} toggle={toggleModal} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}><b>Find Location</b></ModalHeader>
                <ModalBody>
                    <iframe ref={apaFrameRef} src={GRL_URL} width="100%" height="400px" title="Get Address" onLoad={handleMessageToIframe} style={{ width: '100%', height: '650px' }}></iframe>
                </ModalBody>

            </Modal>
            </>
        // </Container>
    );
};

UpdateClientInformation.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {

    if (data && data?.clientInfoData) {
        return {
            initialValues: {
                clientName: data.clientInfoData.clientName,
                accountNo: data.clientInfoData.accountNo,
                // address: data.clientInfoData.clientAddress,
                emailId: data.clientInfoData.emailId,
                clientAccountantEmail: data.clientInfoData.clientAccountantEmail,
                clientAccountantName: data.clientInfoData.clientAccountantName,
                clientAccountantMobile: data.clientInfoData.clientAccountantMobile,
                clientTechName: data.clientInfoData.clientTechName,
                mobileNo: data.clientInfoData?.mobileNo,
                status: data.clientInfoData.status === 1 ? true : false,
                subscriptionStartDate: data.clientInfoData?.subscriptionStartDate,
                subscriptionEndDate: data.clientInfoData?.subscriptionEndDate,
                inactivePollingInterval: data.clientInfoData?.inactivePollingInterval,
                // etaPollingInterval: data.clientInfoData?.etaPollingInterval,
                deliveryPollingInterval: data.clientInfoData?.deliveryPollingInterval,
                activePollingInterval: data.clientInfoData?.activePollingInterval,
                timeZoneInfo: { "value": data.clientInfoData?.timeZoneInfo?.timeZoneId, "label": data.clientInfoData?.timeZoneInfo?.zoneName },
                maxHubManagerCount: "1",
                maxSmsCount: data.clientInfoData?.maxSmsCount,
                maxDeviceCount: data.clientInfoData?.maxDeviceCount,
                maxHubCount: data.clientInfoData?.maxHubCount,
                maxMerchantCount: data.clientInfoData?.maxMerchantCount,
                perMaxMerchantUserCount: data.clientInfoData?.perMaxMerchantUserCount,
                maxHubOperatorCount: data.clientInfoData?.maxHubOperatorCount,
                customerId: data.clientInfoData.customerId,
                customerSubscriptionPlanInfo: { "value": data.clientInfoData?.customerSubscriptionPlanInfo?.subscriptionPlanId, "label": data.clientInfoData?.customerSubscriptionPlanInfo?.planName },
                customerPaymentPlanInfo: { "value": data.clientInfoData?.customerPaymentPlanInfo?.paymentPlanId, "label": data.clientInfoData?.customerPaymentPlanInfo?.planName }
            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'UpdateClientInformationForm', enableReinitialize: true })(UpdateClientInformation))